function get_workflow_name(binding = {}) {
  return binding.workflow_name || binding.name || 'Untitled workflow';
}

function get_workflow_status(binding = {}) {
  if (binding.workflow_status || binding.status) {
    return String(binding.workflow_status || binding.status).toUpperCase();
  }

  return binding.is_active === false ? 'INACTIVE' : 'ACTIVE';
}

function get_stage_summary(binding = {}) {
  return binding.stage_summary
    || binding.description
    || '3 stages: Submitted -> Under review -> Approved';
}

function map_binding(binding = {}) {
  const workflow_name = get_workflow_name(binding);

  return {
    workflow_name,
    status: get_workflow_status(binding),
    stage_summary: get_stage_summary(binding),
    raw: binding,
    id: binding.id || binding.workflow || workflow_name,
  };
}

function normalize_id_list(value) {
  const ids = (Array.isArray(value) ? value : [])
    .map((id) => String(id))
    .filter(Boolean);

  return Array.from(new Set(ids));
}

function lists_equal(first, second) {
  if (first === second) return true;
  if (!Array.isArray(first) || !Array.isArray(second)) return false;
  if (first.length !== second.length) return false;
  for (let i = 0; i < first.length; i += 1) {
    if (Reflect.get(first, i) !== Reflect.get(second, i)) return false;
  }
  return true;
}

export default {
  name: 'WorkflowBinding',
  emits: ['bind-workflow', 'remove-workflow', 'update:selected-workflow-ids'],
  props: {
    entityTypeName: {
      type: String,
      default: 'Entity',
    },
    systemName: {
      type: String,
      default: 'ent_supplier_v2',
    },
    formBindingsCount: {
      type: Number,
      default: 0,
    },
    workflowBindings: {
      type: Array,
      default: () => [],
    },
    availableWorkflows: {
      type: Array,
      default: () => [],
    },
    selectedWorkflowIds: {
      type: Array,
      default: () => [],
    },
    creatingWorkflowBinding: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    local_selected_workflow_ids: [],
    workflow_dropdown_open: false,
  }),
  watch: {
    selectedWorkflowIds: {
      immediate: true,
      handler(next) {
        const next_ids = normalize_id_list(next);
        if (!lists_equal(next_ids, this.local_selected_workflow_ids)) {
          this.local_selected_workflow_ids = next_ids;
        }
      },
    },
    local_selected_workflow_ids(next) {
      const next_ids = normalize_id_list(next);
      const prop_ids = normalize_id_list(this.selectedWorkflowIds);

      if (!lists_equal(next_ids, prop_ids)) {
        this.$emit('update:selected-workflow-ids', next_ids);
      }
    },
  },
  computed: {
    has_workflow() {
      return this.workflowBindings.length > 0;
    },
    workflow_count() {
      return this.workflowBindings.length;
    },
    current_bindings() {
      return this.workflowBindings.map(map_binding);
    },
    selected_workflows_count() {
      return Array.isArray(this.local_selected_workflow_ids) ? this.local_selected_workflow_ids.length : 0;
    },
    selected_workflows_label() {
      if (!this.availableWorkflows.length) return 'No unbound workflows available';
      if (!this.selected_workflows_count) return 'Select workflow(s) to bind';
      return `${this.selected_workflows_count} workflow${this.selected_workflows_count === 1 ? '' : 's'} selected`;
    },
  },
  mounted() {
    document.addEventListener('click', this.on_document_click, true);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.on_document_click, true);
  },
  methods: {
    on_document_click(event) {
      if (!this.workflow_dropdown_open) return;
      const root = this.$refs?.workflowMultiselect;
      if (root && !root.contains(event.target)) {
        this.workflow_dropdown_open = false;
      }
    },
    toggle_workflow_dropdown() {
      if (this.creatingWorkflowBinding) return;
      this.workflow_dropdown_open = !this.workflow_dropdown_open;
    },
    bind_selected_workflows() {
      this.workflow_dropdown_open = false;
      this.$emit('bind-workflow');
    },
  },
};
